import { useEffect } from 'react';

export const useScroll2view = (selector, deps) => {
  useEffect(() => {
    const el = document.querySelector(selector);
    el && el.scrollIntoView({ behavior: 'smooth' });
  }, deps);
};
